import { useCallback } from 'react';

import { logException } from '@atlassian/conversation-assistant-instrumentation/services/sentry';
import { JIRA_SMART_CREATE_TABLE_CLIENT_ID } from '@atlassian/rovo-content-bridge-api-commands/clients/jira-smart-create-modal';
import {
	JiraContextCommand,
	type JiraContextCommandResult,
} from '@atlassian/rovo-content-bridge-api-commands/commands/jira-draft-data-command';

import { useBridgeSendCommand } from '../context/useBridgeSendCommand';

export const useDraftDataAction = (): {
	requestJiraContext: () => Promise<JiraContextCommandResult | undefined>;
} => {
	const { sendCommand } = useBridgeSendCommand();

	const requestJiraContext = useCallback(async (): Promise<
		JiraContextCommandResult | undefined
	> => {
		try {
			const invocation = await sendCommand(JiraContextCommand, {
				receiverId: JIRA_SMART_CREATE_TABLE_CLIENT_ID,
				buffer: false,
			});
			return (await invocation.result()) ?? undefined;
		} catch (error) {
			logException({
				exception: error,
				name: 'SendJiraContextCommandError',
			});
			return undefined;
		}
	}, [sendCommand]);

	return {
		requestJiraContext,
	};
};
